import styled from "styled-components";
import { Colors } from "~/config/Colors";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 1rem;

  .Etapa_div_addPrioridades {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 10rem;
    height: 3rem;
  }
`;

export const SelectColor = styled.div`
  display: flex;
  min-width: 7.04rem;
  height: 2.5rem;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 0.5rem;
  margin-right: 0.5rem;
  cursor: pointer;

  .color {
    ${(props) => props?.color ? `background: #${props?.color};` : `background: #8F9DAF;`}
    height: 100%;
    min-width: 4.54rem;
    border-radius: 0.5em 0 0 0.5rem;
  }

  .button {
    background: ${Colors?.Color23};
    height: 100%;
    width: 100%;
    border-radius: 0 0.5em 0.5em 0;
  }
`;

export const ModalColor = styled.div`
  padding: 1em 0 0 1rem;
  background: ${Colors?.Color23};
  border-radius: 1rem;
  box-shadow: 0px 0px 19px 0px rgb(4 4 4 / 25%) !important;
  height: fit-content;
  
  position: absolute;
  top: -10.5rem;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 16rem;
  left: 4rem;
`;

export const ItemColor = styled.div`
  ${(props) => props?.color ? `background: #${props?.color};` : `background: #8F9DAF;`}
  min-height: 2rem;
  min-width: 2rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  margin-right: 1rem;
  cursor: pointer;
`;
